import { getCurrencyLabel } from "../../confirmations/constants/currencies.config";
import type { EnhancedCountry } from "../../dispersions/types/dispersions-api.types";

export type CurrencyOption = { value: string; label: string };

/** Build unique currency options from countries list; label format "Peso Colombiano (COP)". */
export function buildCurrencyOptionsFromCountries(countries: EnhancedCountry[]): CurrencyOption[] {
  const seen = new Set<string>();
  const options: CurrencyOption[] = [];
  for (const c of countries) {
    if (seen.has(c.currency)) continue;
    seen.add(c.currency);
    options.push({
      value: c.currency,
      label: getCurrencyLabel(c.currency),
    });
  }
  return options.sort((a, b) => a.label.localeCompare(b.label));
}
